
// export default EditParkModal;
import React from "react";
import theme from "../../components/shared/theme";

const EditParkModal = ({ item, onChange, onCancel, onSubmit }) => {
  if (!item) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: theme.spacing.lg,
          borderRadius: theme.radius.lg,
          width: "450px",
        }}
      >
        <h2 style={{ marginBottom: theme.spacing.md }}>Edit Park Details</h2>

        {/* <label>Project Code</label>
        <input
          type="text"
          value={item.project_code}
          onChange={(e) => onChange("project_code", e.target.value)}
          style={{ width: "100%", padding: 8, marginBottom: 12 }}
        /> */}

        <label>Park / Stretch Name</label>
        <input
          type="text"
          value={item.park_stretch_name}
          onChange={(e) => onChange("park_stretch_name", e.target.value)}
          style={{ width: "100%", padding: 8, marginBottom: 12 }}
        />

        <label>Project Type</label>
        <select
          value={item.project_type}
          onChange={(e) => onChange("project_type", e.target.value)}
          style={{ width: "100%", padding: 8, marginBottom: 12 }}
        >
          <option value="">Select Type</option>
          <option value="Park">Park</option>
          <option value="Stretch">Stretch</option>
        </select>

        <div style={{ display: "flex", gap: 10 }}>
          <button
            onClick={onCancel}
            style={{
              flex: 1,
              background: "#ccc",
              padding: 10,
              borderRadius: 6,
            }}
          >
            Cancel
          </button>

          <button
            onClick={onSubmit}
            style={{
              flex: 1,
              background: theme.colors.primary,
              color: "#fff",
              padding: 10,
              borderRadius: 6,
            }}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditParkModal;

